import {connect} from 'react-redux'
import MoreServices from "./moreServices";

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(MoreServices)